// 拷贝src/pages/intelligence/components/ExportTable/components/FormCheckboxGroup.tsx

import React, { FC, Fragment } from 'react';
import { Checkbox, Bubble } from 'tea-component';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { IBasicFormItemProps } from '../../type';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getShowLabel } from '../../utils';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';

// TODO disabled逻辑
const FormCheckbox: FC<IBasicFormItemProps> = (props) => {
  const { options = [], value, field, onChange } = props;
  // console.log('checkbox', props);
  const { formatMessage } = useIntlExtend();

  return (
    <>
      (<Checkbox.Group
        value={value}
        onChange={(value) => onChange(field, value)}
      >
        {
          options?.length > 0 && options?.map((item) => (
            <Bubble
              key={`${item.label || item.labelKey}${item.value}`}
              dark
              className="bubble-all-bg"
              overlayClassName="topcharts-download-bubble"
              trigger="hover"
              placement="top"
              content={getShowLabel(item, formatMessage, 'msg')}
            >
              <Fragment key={`${item.label || item.labelKey}${item.value}`}>
                <Checkbox disabled={item?.isDisable} name={item?.value} style={{ display: item.isShow ? 'inline-block' : 'none' }}>
                  {!item.isNoIcon && item.icon && <img src={getDataSourceIcon(item.icon)} alt="" className="dbi-select-countryicon" />}
                  {getShowLabel(item, formatMessage)}
                  {getShowLabel(item, formatMessage, 'msg') && <TipContext tipText={getShowLabel(item, formatMessage, 'msg')} className="checkbox-group-tip" />}
                </Checkbox>
              </Fragment>
            </Bubble>
          ))
        }
      </Checkbox.Group>)
    </>
  );
};

export default FormCheckbox;
